module.exports = __webpack_public_path__ + "img/hdm_logo.dc3f39c4.svg";